// extracted by mini-css-extract-plugin
export var barre = "navbar-module--barre--26a8f";
export var menu = "navbar-module--menu--6873e";
export var rdvs = "navbar-module--rdvs--031b1";
export var selected = "navbar-module--selected--07e3b";
export var togglemenu = "navbar-module--togglemenu--68d3f";